<template>
  <div>
    <CrudList
      title="Autos y patentes"
      storeName="Cars_cms"
      labelAddNew="Agregar"
      :canAdd="false"
      :canEdit="true"
      sortable
      :canExport="true"
      next-link="/admin/car_brands"
      :breadcrumbs="[
        {
          text: 'Spots y vehículos',
          disabled: false,
          href: '/admin/cars'
        },
        {
          text: 'Autos y patentes',
          disabled: false,
          href: '#'
        }
      ]"
    >
    <template v-slot:user="{item}">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <p>
            {{ item.user && item.user.name ? item.user.name : '' }}
            {{ item.user && item.user.last_name ? item.user.last_name : '' }}
            <br>
            {{ item.user && item.user.email ? item.user.email : '' }}
          </p>
        </v-col>
      </v-row>
    </template>
    <template v-slot:created_at="{item}">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <p>{{ item.created_at ? formatDate(item.created_at) : '' }}</p>
        </v-col>
      </v-row>
    </template>
    <template v-slot:car="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <p>
            {{ item.car_model && item.car_model.brand && item.car_model.brand.name ? item.car_model.brand.name : '' }}
            <br>
            {{ item.car_model && item.car_model.name ? item.car_model.name : '' }}
          </p>
        </v-col>
      </v-row>
    </template>
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";
  import CrudFormMixin from "@/mixins/crud_form";
  export default {
    mixins: [CrudFormMixin],
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },
    },
  };
</script>
